import { can, FEATURE_KEYS } from "./featureAccess";

// File-manager delete is gated on the File Manager feature's `delete` capability
// (both core.folders.folder.delete and core.folders.file.delete carry action=delete).
// Super Admin short-circuits inside can(). `item` is kept in the signature for
// call-site compatibility; deletion is a feature capability, not per-item ownership.
export const canDelete = (item, user) => {
  if (!item || !user) return false;
  return can(user, FEATURE_KEYS.FILE_MANAGER, "delete");
};
